import { render } from "./UpcomingShows.vue?vue&type=template&id=09aa5a6c&scoped=true"
import script from "./UpcomingShows.ts?vue&type=script&lang=js"
export * from "./UpcomingShows.ts?vue&type=script&lang=js"

import "./UpcomingShows.vue?vue&type=style&index=0&id=09aa5a6c&lang=scss&scoped=true"

import exportComponent from "/Users/lucatescari/Documents/Projects/Private/rt-songpage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09aa5a6c"]])

export default __exports__